import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Phone } from "lucide-react";
import { LogoImage } from "./Logo";
import { PHONE_TEL } from "../site";

const LINKS = [
  { label: "Services", href: "/#services", hash: "#services" },
  { label: "Coverage", href: "/#coverage", hash: "#coverage" },
  { label: "Reviews", href: "/#reviews", hash: "#reviews" },
  { label: "FAQ", href: "/#faq", hash: "#faq" },
  { label: "Contact", href: "/contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, link) => {
    if (!link.hash) return; // normal page link
    e.preventDefault();
    if (pathname === "/") {
      document.querySelector(link.hash)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate({ pathname: "/", hash: link.hash });
    }
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow,border-color] duration-300 border-b ${
        scrolled || pathname !== "/"
          ? "bg-white/70 backdrop-blur-xl border-zinc-200/80 shadow-[0_8px_32px_rgba(0,0,0,0.04)]"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between gap-6">
        <Link
          to="/"
          data-testid="header-logo-link"
          className="flex items-center focus-visible:ring-2 focus-visible:ring-blue-500 rounded-lg"
        >
          <LogoImage className="h-10 md:h-12 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="header-nav">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={(e) => go(e, l)}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-zinc-600 hover:text-zinc-950 transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-blue-500 rounded"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={PHONE_TEL}
          data-testid="header-emergency-call-button"
          className="relative inline-flex items-center gap-2 rounded-full bg-alert px-4 md:px-5 py-2.5 text-sm font-semibold text-white hover:bg-red-600 transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-blue-500"
        >
          <span className="absolute inset-0 rounded-full bg-alert animate-ping opacity-20" aria-hidden="true" />
          <Phone className="h-4 w-4 relative" />
          <span className="relative">24/7 Emergency</span>
        </a>
      </div>
    </header>
  );
};
